import React, { Component, Fragment } from 'react';
import Checkbox from 'Components/Checkbox';
import Cx from 'classnames';
import {
    TypographyT43
  } from "Components/Common/Typography/index";
import {
    TBody,
    THead,
    Table,
    TableWrapper,
    Td,
    Th,
    Tr,
  } from "Components/Common/Table/TableT1";
  import ModalT1 from 'Components/Common/Modal/ModalT1';

export default class VehicleDetailsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        const { data } = this.props;
        debugger;
        return (
            <Fragment>
                <ModalT1
                isOpenState={true}
                handleOnClickForClose={this.props.onCancel}
                >
                    <div className="bg-white box-shadow ph-20 pv-20 br-5">
                        <div className="mb-30 tCenter header-medium-color fSemibold fs-18">
                            {'Vehicle Details'}
                        </div>
                        <TableWrapper>
                            <Table>
                                <THead>
                                <Tr>
                                    <Th style={{'textAlign': 'center'}}>Transporter</Th>
                                    <Th style={{'textAlign': 'center'}}>Vehicle Type</Th>
                                    <Th style={{'textAlign': 'center'}}>Number of Vehicle</Th>
                                    <Th style={{'textAlign': 'center'}}>Price Per Vehicle</Th>
                                    <Th style={{'textAlign': 'center'}}>Price</Th>
                                </Tr>
                                </THead>
                                <TBody>
                                    {(data || []).map((el, index) => (
                                        <>
                                            {(el.transporter_vehicle || []).map((vehicle) => (
                                                <Tr>
                                                    <Td style={{'textAlign': 'center'}} rowspan={(data.transporter_vehicle || []).length}>
                                                        <TypographyT43>
                                                            {el.name}
                                                        </TypographyT43>
                                                    </Td>
                                                    <Td style={{'textAlign': 'center'}}>
                                                        <TypographyT43>
                                                            {vehicle.name}
                                                        </TypographyT43>
                                                    </Td>
                                                    <Td style={{'textAlign': 'center'}}>
                                                        <TypographyT43>
                                                            {vehicle.number_of_vehicle}
                                                        </TypographyT43>
                                                    </Td>
                                                    <Td style={{'textAlign': 'center'}}>
                                                        <TypographyT43>
                                                            {vehicle.price_per_vehicle}
                                                        </TypographyT43>
                                                    </Td>
                                                    <Td style={{'textAlign': 'center'}}>
                                                        <TypographyT43>
                                                            {vehicle.price}
                                                        </TypographyT43>
                                                    </Td>
                                                </Tr>
                                            ))}
                                        </>))}
                                </TBody>
                            </Table>
                        </TableWrapper>
                       
                    </div>    
                </ModalT1> 
            </Fragment>
        )
    }
}